/**
 * @flow
 * @relayHash aee4f4f0dcb908846b649ca39f345922
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ConfigurableBlockList_viewer$ref = any;
export type ConfigurableBlockList_Refetch_QueryVariables = {||};
export type ConfigurableBlockList_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ConfigurableBlockList_viewer$ref
  |}
|};
export type ConfigurableBlockList_Refetch_Query = {|
  variables: ConfigurableBlockList_Refetch_QueryVariables,
  response: ConfigurableBlockList_Refetch_QueryResponse,
|};
*/


/*
query ConfigurableBlockList_Refetch_Query {
  viewer {
    ...ConfigurableBlockList_viewer
    id
  }
}

fragment ConfigurableBlockList_viewer on Viewer {
  blocks: configurableBlocks {
    edges {
      node {
        id
        ...ConfigurableBlockListItem_block
      }
    }
  }
}

fragment ConfigurableBlockListItem_block on ConfigurableBlock {
  id
  type
  slug
  config
  active
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ConfigurableBlockList_Refetch_Query",
  "id": null,
  "text": "query ConfigurableBlockList_Refetch_Query {\n  viewer {\n    ...ConfigurableBlockList_viewer\n    id\n  }\n}\n\nfragment ConfigurableBlockList_viewer on Viewer {\n  blocks: configurableBlocks {\n    edges {\n      node {\n        id\n        ...ConfigurableBlockListItem_block\n      }\n    }\n  }\n}\n\nfragment ConfigurableBlockListItem_block on ConfigurableBlock {\n  id\n  type\n  slug\n  config\n  active\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ConfigurableBlockList_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ConfigurableBlockList_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ConfigurableBlockList_Refetch_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "blocks",
            "name": "configurableBlocks",
            "storageKey": null,
            "args": null,
            "concreteType": "ConfigurableBlockConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ConfigurableBlockEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ConfigurableBlock",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "config",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "active",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '03925013dedda67da4119ddd87c13803';
module.exports = node;



// WEBPACK FOOTER //
// src/components/configurable-blocks/__generated__/ConfigurableBlockList_Refetch_Query.graphql.js